<app-custom-form [data]="formObj" [submitAction]="submitAction" 
    (actionClicked)="apply($event)" (fieldChange)="changeField($event)" reverseActions="true" [listenToChanges]="listenToChanges">
</app-custom-form>